export default "__VITE_ASSET__CGFSCljC__"